function RightFoot ()
{
    return (
        <div className="self-start mt-14 mr-20">
            <div className="flex gap-4 items-center">
                <div className="flex flex-col gap-4">
                <div className="text-white text-lg">Subscribe to our newsletter:</div>
                    <input type="text" placeholder="Enter your Email" className="bg-lightPurple w-96 rounded-lg pl-4 h-9 text-lg" />
                </div>
            </div>
        </div>
    );
}

export default RightFoot;